import { Icon } from '@iconify/react'
import Card from '../common/Card'
import Button from '../common/Button'

const WebsiteConnectionEmptyState = ({ onAddClick }) => {
  return (
    <Card>
      <div className="text-center py-12">
        <Icon icon="mdi:web-off" className="text-6xl text-text-secondary mx-auto mb-4" />
        <h3 className="text-xl font-semibold text-text-dark mb-2">No Website Connections</h3>
        <p className="text-text-secondary mb-6">Get started by adding your first website connection</p>
        <Button icon="mdi:plus" onClick={onAddClick}>
          Add Connection
        </Button>
      </div>
    </Card>
  )
}

export default WebsiteConnectionEmptyState
